import React from 'react';

import marina from '../../assets/modal/marina-61e1818cfc0849aedb88991f1b809145.png';

import LoginForm from './LoginForm';
import LoginWithCAM4 from './LoginWithCAM4';
import '../../css/styles.css';



class LoginModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isErrorVisible: false };
  }

  onError = (err) => {
    if (err) {
      this.setState({ isErrorVisible: true });
    }
  };

  render() {
    const { show, closeModal, showAffiliateLoginModal, user } = this.props;
    const { isErrorVisible } = this.state;

    if (showAffiliateLoginModal && user.authenticated) {
      return null;
    }

    return (
      <div
        aria-hidden="false"
        className="modal nakednews-modal in"
        data-event-tracking={true}
        data-source="home/index"
        data-source-url="https://www.nakednews.com/"
        id="login_prompt"
        role="dialog"
        style={{ display: show ? 'block' : 'none' }}
        tabIndex={-1}
      >
        <div
          className="modal-backdrop in"
          style={{ height: '100%' }}
          onClick={closeModal.bind(this, false)}
        />
        <div className="modal-dialog login-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <div className="modal-background">
                <img
                  alt="Marina"
                  src={marina}
                />
              </div>
              <div className="modal-main-container">
                <div className="modal-main">
                  <div className="modal-title">
                    Login to NN
                  </div>
                  <LoginWithCAM4 shouldDoLogin={false} user={user} />
                  <div
                    className="nakednews-form-container login-form"
                    style={{ position: 'relative' }}
                  >
                    <LoginForm
                      onError={this.onError}
                      onSubmitted={closeModal}
                    />
                    {isErrorVisible && (
                      <div
                        className="nakednews-form-error"
                        style={{
                          position: 'relative',
                          bottom: '5px',
                          left: 0,
                          width: '100%',
                          height: '3em',
                          color: '#b51023',
                          lineHeight: '1em',
                          textAlign: 'center',
                        }}
                      >
                        Invalid username or password.
                      </div>
                    )}
                  </div>
                  <a
                    className="modal-link"
                    href="/account/password/new"
                  >
                    Forgot your username or password?
                  </a>
                  <a
                    className="modal-link"
                    href="/account/purchase"
                  >
                    Need an account?
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LoginModal;
